import { useMutation } from "@tanstack/react-query"
import { createLearningGroupFetch } from "store/middlewares/affiliation.crud"

const useCreateLearningGroup = () => {

    const { mutateAsync: createLearningGroup } = useMutation({
        mutationFn: createLearningGroupFetch
    })

    return createLearningGroup
}

export default useCreateLearningGroup